import { render, staticRenderFns } from "./NavPopup.vue?vue&type=template&id=527d6c58&scoped=true"
import script from "./NavPopup.vue?vue&type=script&lang=js"
export * from "./NavPopup.vue?vue&type=script&lang=js"
import style0 from "./NavPopup.vue?vue&type=style&index=0&id=527d6c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527d6c58",
  null
  
)

export default component.exports